import { TranslationResource } from './en';

// Spanish translations must follow the same structure as English
const es: TranslationResource = {
  translation: {
    // Common
    "welcome": "Bienvenido a nuestra aplicación",
    "language": "Idioma",
    "continue": "Continuar",
    "or": "O",
    "need_help": "¿Necesitas ayuda?",
    "powered_by": "Desarrollado por",
    "copyright": "Derechos de autor",
    "header_logo": "Logotipo del constructor",
    "try_again": "Intentar de nuevo",
    "uh_oh": "¡Ups!",
    "community": "Comunidad",
    "accept": "Aceptar",
    
    // Languages
    "english": "Inglés",
    "spanish": "Español",
    
    // Authentication
    "sign_in_with_phone": "Inicia sesión con tu número de teléfono.",
    "need_account": "¿Necesitas una cuenta con NterNow?",
    "register_here": "Regístrate aquí",
    "phone_placeholder": "000-000-0000",
    
    // Navigation
    "back": "Atrás",
    
    // Errors
    "phone_required": "Se requiere tu número de teléfono. Por favor, vuelve a ingresarlo o regístrate para obtener una cuenta.",
    "property_not_found_title": "Propiedad no encontrada",
    "property_unavailable_title": "Propiedad no disponible",
    "tour_unavailable_title": "Visita no disponible",
    "session_expired_title": "Sesión expirada",
    "tour_restart_needed_title": "Reiniciemos tu visita",
    "temporary_problem_title": "Problema temporal",
    "refresh_needed_title": "Se necesita actualizar",
    "something_went_wrong_title": "Algo salió mal",
    "property_not_found_message": "No se encontró esta propiedad o ya no está disponible.",
    "property_unavailable_message": "Esta propiedad no está disponible para visitas autoguiadas en este momento.",
    "tour_unavailable_message": "Esta visita no se puede iniciar en este momento.",
    "identity_verification_required_message": "Se requiere verificar tu identidad antes de iniciar esta visita.",
    "tour_location_not_confirmed_message": "No pudimos confirmar tu ubicación para esta visita. Comprueba los permisos de ubicación o comunícate con soporte.",
    "session_expired_message": "Tu sesión ha expirado. Por favor, inténtalo de nuevo.",
    "tour_restart_needed_message": "No pudimos continuar la visita anterior. Elige otra propiedad o comunícate con soporte.",
    "temporary_problem_message": "No pudimos cargar esta propiedad debido a un problema temporal de conexión.",
    "refresh_needed_message": "No pudimos actualizar la información de la propiedad. Por favor, inténtalo de nuevo.",
    "something_went_wrong_message": "Algo salió mal al cargar esta propiedad. Por favor, inténtalo de nuevo.",
    "property_id_invalid_message": "El identificador de la propiedad no es válido. Verifícalo e inténtalo de nuevo.",
    "access_problem_retry_help": "Inténtalo de nuevo si el problema es temporal o elige otra propiedad.",
    "access_problem_terminal_help": "Elige otra propiedad o comunícate con soporte para obtener ayuda.",
    "no_active_lock": "Lo sentimos, hay un problema para acceder. No hay una cerradura activa en la propiedad. Por favor, llame al soporte técnico o pruebe con otra propiedad habilitada para visitas.",
    "access_issue": "Lo sentimos, hay un problema para acceder. {propStatusDescription}. Por favor, llame al soporte técnico o pruebe con otra propiedad habilitada para visitas.",
    "accept_terms_error": "Debes aceptar nuestros términos y condiciones para continuar",
    
    // COVID Notice
    "covid_notice": "Entiendo que durante la crisis de COVID-19, estoy recorriendo bajo mi propio riesgo y me aseguraré de seguir las 5 pautas recomendadas por los CDC al realizar un recorrido autoguiado. Para más información:",
    "covid_policy": "Política de COVID-19",
    
    // Property viewing
    "select_tour_date": "Seleccionar fecha de visita",
    "previous_tours": "Visitas anteriores",
    "upcoming_tours": "Próximas visitas",
    "choose_community": "Elegir comunidad",
    "search_community": "Buscar comunidad",
    "book_a_tour": "Reservar una visita",
    "tours": "Visitas",
    "enter_property_id": "Ingrese ID de propiedad",
    "property_id_placeholder": "Ingrese el ID de propiedad de 5 dígitos en la puerta",
    "property_label": "Propiedad",
    "explore_other_properties": "Explorar otras propiedades disponibles",
    "find_other_properties": "Encontrar otras propiedades",
    
    // Account
    "edit_profile": "Editar perfil",
    "my_profile": "Mi perfil",
    "sign_in": "Iniciar sesión",
    "sign_out": "Cerrar sesión",
    
    // Disclosure
    "disclosure_consent": "Al seleccionar esta casilla, acepto que tengo 18 años o más y acepto ser contactado por NterNow o el propietario o administrador de la propiedad de acuerdo con la",
    
    // Other pages
    "how_it_works": "Cómo funciona",
    "feedback": "Comentarios",
    "offer": "Oferta",
    "help": "Ayuda",
    "support": "Soporte",
    "privacy_policy": "Política de privacidad",
    "terms_legal": "Términos",
    "terms_of_service": "Términos de servicio",
    "housing_opportunities": "Oportunidades de vivienda",
    
    // Homepage
    "ready_tour": "¿Listo para una visita?",
    "start_touring_button": "Empieza a recorrer ahora"
  }
};

export default es;
